
import { Vue } from "vue-class-component";

export default class Sti extends Vue {}
